/**
 * @Module Chart
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chart'
})
export class ChartPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if(value === null) return 'Not assigned';
    return `${value}/CHART`;
  }

}
